import React from "react";
import "./SidebarDisplayArea.scss";
import { useDocumentTitle } from "../../../hooks";
import SidebarDisplayAreaContent from "./SidebarDisplayAreaContent";

interface SidebarDisplayAreaProps {
  title: string;
  className?: string;
  children?: React.ReactNode;
}

function toCssClassName(str: string): string {
  if (!str) {
    return "";
  }

  // Convert to lowercase, replace spaces with hyphens and remove invalid characters
  let className = str
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-_]/g, "");

  // Ensure the class name doesn't start with a digit
  if (className.match(/^\d/)) {
    className = "_" + className;
  }

  // Shorten to a maximum of 30 characters
  return className.substring(0, 30);
}

const SidebarDisplayArea: React.FC<SidebarDisplayAreaProps> = ({
  title,
  className,
  children,
}) => {
  useDocumentTitle({ title });
  return (
    <div
      className={`sidebar-display-area-wrapper ${toCssClassName(title)}${
        className ? ` ${className}` : ""
      }`}
    >
      <div className={"sidebar-display-area-title-wrap"}>
        <h2 className={"sidebar-display-area-title"}>{title}</h2>
      </div>
      <SidebarDisplayAreaContent>{children}</SidebarDisplayAreaContent>
    </div>
  );
};

export default SidebarDisplayArea;
